module.exports = __webpack_public_path__ + "img/boy_holding_pencil.084223c6.svg";